import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import PropTypes from 'prop-types';
import { abVariations } from '@utils/abHelper';
import useExperiments from '@stores/experiments';
import { getExperimentVariation } from '@stores/selectors/experiments';
import AboutCourse from '@cont/BatchGroup/WebKeyOutcomes/AboutCourse';
import WhatWillYouLearn from '@cont/BatchGroup/WebKeyOutcomes/WhatWillYouLearn';
import WhoIsThisCourseFor from '@cont/BatchGroup/WebKeyOutcomes/WhoIsThisCourseFor';
import TrialClasses from '@cont/BatchGroup/TrialClasses';
import { BG_OVERVIEW_TAB_ORDERING } from '@cont/BatchGroup/constants';

const TrailClassesWrapper = styled.div`
  margin-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_14B};
  }
`;

const OverViewSection = ({
  isEnrolled,
  trialClasses,
  batchUID,
  goalUID,
  batchDetails
}) => {
  const tabOrderingVariation = useExperiments(
    getExperimentVariation(BG_OVERVIEW_TAB_ORDERING)
  );
  const { description, metaInfo } = batchDetails;
  // if user is Enrolled we will wont check the tabOrderingVariation value.

  if (isEnrolled) {
    return (
      <>
        <AboutCourse description={description} />
        <WhatWillYouLearn courseInfo={metaInfo?.course_info} />
      </>
    );
  }
  // if user is not Enrolled we will check the tabOrderingVariation value
  if (tabOrderingVariation === abVariations.TEST_2) {
    return (
      <>
        <AboutCourse description={description} />
        <WhatWillYouLearn courseInfo={metaInfo?.course_info} />
        <WhoIsThisCourseFor
          recommendationInfo={metaInfo?.recommendation_info}
        />
        {(trialClasses?.data?.length && (
          <TrailClassesWrapper>
            <TrialClasses
              batchUID={batchUID}
              trialClasses={trialClasses}
              goalUID={goalUID}
              disabledTopicGroup
              hideLessonCount
            />
          </TrailClassesWrapper>
        )) ||
          null}
      </>
    );
  }
  // if user is not Enrolled we will wont check the tabOrderingVariation===abVariations.TEST_1 value or a fallback of a/b experiment.
  return (
    <>
      <AboutCourse description={description} />
      {(trialClasses?.data?.length && (
        <TrailClassesWrapper>
          <TrialClasses
            batchUID={batchUID}
            trialClasses={trialClasses}
            goalUID={goalUID}
            disabledTopicGroup
            hideLessonCount
          />
        </TrailClassesWrapper>
      )) ||
        null}
      <WhatWillYouLearn courseInfo={metaInfo?.course_info} />
      <WhoIsThisCourseFor recommendationInfo={metaInfo?.recommendation_info} />
    </>
  );
};
export default OverViewSection;
OverViewSection.propTypes = {
  isEnrolled: PropTypes.bool
};

OverViewSection.defaultProps = {
  isEnrolled: false
};
